import styled from 'styled-components'
import ViewColumnIcon from '@mui/icons-material/ViewColumn'
import useViewport from '../../../hooks/useViewport'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  height: 36px;
  padding: 0 16px;
  border-radius: 50px;
  background-color: #f1f3f5;
  cursor: pointer;
`

export const ColumnSeletor = ({ onClick }) => {
  const { width } = useViewport()
  const { t } = useTranslation('common')

  return (
    <Container onClick={onClick}>
      <ViewColumnIcon sx={{ color: '#858B92' }} />
      {width > 830 && <span>{t('columns.title')}</span>}
    </Container>
  )
}
